import { EventEmitter, Injectable, Type, ViewContainerRef } from '@angular/core';
import { Drawer } from 'primeng/drawer';

@Injectable({
  providedIn: 'root'
})
export class PanelService {
  panel: Drawer;
  container: ViewContainerRef;

  // For PORTALS, see
  // https://stackoverflow.com/questions/56772447/change-mat-sidenav-content-dynamically-from-any-component
  // https://stackblitz.com/edit/mat-dynamic-panel
  public drawerToggle = new EventEmitter<boolean>();

  initialize(component?: Type<unknown>, inputs?: any) {
    this.container.clear();
    this.open();
    if (component) {
      const componentRef = this.container.createComponent(component);
      if (inputs) {
        for (const [key, value] of Object.entries(inputs)) {
          componentRef.setInput(key, value);
        }
      }
    }
    return true;
  }

  clear() {
    this.container.clear();
  }

  open() {
    this.drawerToggle.emit(true);
  }

  close() {
    this.clear();
    this.drawerToggle.emit(false);
  }
}
